import { useFormikContext, Field } from "formik";
import React from "react";
import ErrorMessage from "../components/ErrorMessage"

function Benefits() {
  const { errors, touched } = useFormikContext();

  return (
    <div>
        
 <h2 class="heading1">Income from benefits</h2>
 <ErrorMessage errors={errors}/>
<p>Provide details of any benefits you receive.  </p>
    <fieldset class="question-section">
        <legend class="heading3 mbottom-10">Attendance Allowance (weekly)</legend>
        <div class="form__control form__radio">
            <Field type="radio" id="attendanceallowance_higher" name="attendanceallowance" value="89.60"/>
            <label class="form__label" htmlFor="attendanceallowance_higher"><span>Higher rate (£89.60)</span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="attendanceallowance_lower" name="attendanceallowance" value="60.00"/>
            <label class="form__label" htmlFor="attendanceallowance_lower"><span>Lower rate (£60.00) </span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="attendanceallowance_no" name="attendanceallowance" value="0"/>
            <label class="form__label" htmlFor="attendanceallowance_no"><span>I don't receive this</span></label>
        </div>
    </fieldset>
    <fieldset class="question-section">
        <legend class="heading3 mbottom-10">Disability Living Allowance - care component (weekly)</legend>
        <div class="form__control form__radio">
            <Field type="radio" id="disabilityallowance_higher" name="disabilityallowance" value="89.60"/>
            <label class="form__label" htmlFor="disabilityallowance_higher"><span>Higher rate (£89.60) </span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="disabilityallowance_middle" name="disabilityallowance" value="60.00"/>
            <label class="form__label" htmlFor="disabilityallowance_middle"><span>Middle rate (£60.00) </span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="disabilityallowance_lower" name="disabilityallowance" value="23.70"/>
            <label class="form__label" htmlFor="disabilityallowance_lower"><span>Lower rate (£23.70) </span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="disabilityallowance_no" name="disabilityallowance" value="0"/>
            <label class="form__label" htmlFor="disabilityallowance_no"><span>I don't receive this</span></label>
        </div>
    </fieldset>

    <fieldset class="question-section">
        <legend class="heading3 mbottom-10">Disability Living Allowance - mobility component (weekly) </legend>
        <div class="form__control form__radio">
            <Field type="radio" id="disabilitymobility_higher" name="disabilitymobility" value="62.55"/>
            <label class="form__label" htmlFor="disabilitymobility_higher"><span>Higher rate (£62.55) </span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="disabilitymobility_lower" name="disabilitymobility" value="23.70"/>
            <label class="form__label" htmlFor="disabilitymobility_lower"><span>Lower rate (£23.70) </span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="disabilitymobility_no" name="disabilitymobility" value="0"/>
            <label class="form__label" htmlFor="disabilitymobility_no"><span>I don't receive this </span></label>
        </div>
    </fieldset>

    <fieldset class="question-section">
        <legend class="heading3 mbottom-10">Personal Independence Payment (PIP) - care component (weekly)</legend>
        <div class="form__control form__radio">
            <Field type="radio" id="personalindepenence_higher" name="personalindepenence" value="89.60"/>
            <label class="form__label" htmlFor="personalindepenence_higher"><span>Enhanced rate (£89.60) </span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="personalindepenence_lower" name="personalindepenence" value="60.00"/>
            <label class="form__label" htmlFor="personalindepenence_lower"><span>Standard rate (£60.00) </span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="personalindepenence_no" name="personalindepenence" value="0"/>
            <label class="form__label" htmlFor="personalindepenence_no"><span>I don't receive this</span></label>
        </div>
    </fieldset>

    <fieldset class="question-section">
        <legend class="heading3 mbottom-10">Personal Independence Payment (PIP) - mobility component (weekly)</legend>
        <div class="form__control form__radio">
            <Field type="radio" id="personalindepenence_mobility_higher" name="personalindepenence_mobility" value="62.55"/>
            <label class="form__label" htmlFor="personalindepenence_mobility_higher"><span>Enhanced rate (£62.55)</span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="personalindepenence_mobility_lower" name="personalindepenence_mobility" value="23.70"/>
            <label class="form__label" htmlFor="personalindepenence_mobility_lower"><span>Standard rate (£23.70)</span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="personalindepenence_mobility_no" name="personalindepenence_mobility" value="0"/>
            <label class="form__label" htmlFor="personalindepenence_mobility_no"><span>I don't receive this</span></label>
        </div>
    </fieldset>

    <fieldset class="question-section">
        <legend class="heading3 mbottom-10">Do you receive Armed Forces Independence Payment (weekly)</legend>
        <div class="form__control form__radio">
            <Field type="radio" id="armedforces_yes" name="armedforces" value="1"/>
            <label class="form__label" htmlFor="armedforces_yes"><span>Yes</span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="armedforces_no" name="armedforces" value="0"/>
            <label class="form__label" htmlFor="armedforces_no"><span>No</span></label>
        </div>
    </fieldset>

    <fieldset class="question-section">
        <div class="form__control form__input">
            <label class="heading3 mbottom-10" htmlFor="employmentsupport">Employment Support Allowance</label>
            <span class="inline pound-font">£</span>
        
            <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="employmentsupport" name="employmentsupport" class="input-width--300"/>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="employmentsuppport-per-weekly" name="employmentsuppport_per" value="0"/>
            <label class="form__label" htmlFor="employmentsuppport-per-weekly"><span>Weekly</span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="employmentsuppport-per-month" name="employmentsuppport_per" value="1"/>
            <label class="form__label" htmlFor="employmentsuppport-per-month"><span>Four weekly</span></label>
        </div>
    </fieldset>

    <fieldset class="question-section">
        <div class="form__control form__input">
            <label class="heading3 mbottom-10" htmlFor="incomesupport">Income support</label>
            <span class="inline pound-font">£</span>
      
            <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="incomesupport" name="incomesupport_name" class="input-width--300"/>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="incomesupport-per-weekly" name="incomesupport_per" value="0"/>
            <label class="form__label" htmlFor="incomesupport-per-weekly"><span>Weekly</span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="incomesupport-per-monthly" name="incomesupport_per" value="1"/>
            <label class="form__label" htmlFor="incomesupport-per-monthly"><span>Four weekly</span></label>
        </div>
    </fieldset>

    <fieldset class="question-section">
        <div class="form__control form__input">
            <label class="heading3 mbottom-10" htmlFor="universalcredit">Universal credit</label>
            <span class="inline pound-font">£</span>
           
            <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="universalcredit" name="universalcredit_name" class="input-width--300"/>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="universalcredit-per-weekly" name="universalcredit_per" value="0"/>
            <label class="form__label" htmlFor="universalcredit-per-weekly"><span>Weekly</span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="universalcredit-per-monthly" name="universalcredit_per" value="1"/>
            <label class="form__label" htmlFor="universalcredit-per-monthly"><span>Monthly</span></label>
        </div>
    </fieldset>

    <fieldset class="question-section">
        <div class="form__control form__input">
            <label class="heading3 mbottom-10" htmlFor="carersallowance">Carers allowance</label>
            <span class="inline pound-font">£</span>
            <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="carersallowance" name="carersallowance_name" class="input-width--300"/>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="carersallowance-per-weekly" name="carersallowance_per" value="0"/>
            <label class="form__label" htmlFor="carersallowance-per-weekly"><span>Weekly</span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="carersallowance-per-monthly" name="carersallowance_per" value="1"/>
            <label class="form__label" htmlFor="carersallowance-per-monthly"><span>Monthly</span></label>
        </div>
    </fieldset>

    <fieldset class="question-section">
        <div class="form__control form__input">
            <label class="heading3 mbottom-10" htmlFor="other">Other benefits</label>
            <span class="inline pound-font">£</span>
           
            <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="otherbenefits" name="otherbenefits_name" class="input-width--300"/>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="otherbenefits-per-weekly" name="otherbenefits_per" value="0"/>
            <label class="form__label" htmlFor="otherbenefits-per-weekly"><span>Weekly</span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="otherbenefits-per-monthly" name="otherbenefits_per" value="1"/>
            <label class="form__label" htmlFor="otherbenefits-per-monthly"><span>Monthly</span></label>
        </div>
    </fieldset>
    </div>
  );
}
export default Benefits;